import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import http from "../http-common";

const useBusinessPlan = (uuid) => {
  const [businessPlan, setBusinessPlan] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await http.get(`/business-plan/uuid/${uuid}`);
        setBusinessPlan(result.data);
      } catch (error) {
        toast.error(error.response?.data.message);
      }
    };

    fetchData();
  }, [uuid]);

  return { businessPlan };
};

export default useBusinessPlan;
